const BCM_DEFAULT_LANGUAGE = 'de';

export const USER_LANGUAGE_PREFERENCE_STORAGE_KEY = 'u2b.appearance.language';

export function getUserLanguagePreference(): string | null {
    if (typeof localStorage === 'undefined') {
        return null;
    }

    const stored = localStorage.getItem(USER_LANGUAGE_PREFERENCE_STORAGE_KEY);

    if (!stored || stored === BCM_DEFAULT_LANGUAGE) {
        return stored === BCM_DEFAULT_LANGUAGE ? BCM_DEFAULT_LANGUAGE : null;
    }

    return stored;
}

export function setUserLanguagePreference(language: string): void {
    if (typeof localStorage === 'undefined') {
        return;
    }

    localStorage.setItem(USER_LANGUAGE_PREFERENCE_STORAGE_KEY, language || BCM_DEFAULT_LANGUAGE);
}

export function clearUserLanguagePreference(): void {
    if (typeof localStorage === 'undefined') {
        return;
    }

    localStorage.removeItem(USER_LANGUAGE_PREFERENCE_STORAGE_KEY);
}
